import { createIcon } from './icon-utils';

export const LargeArrowRightIcon = createIcon({
  path: 'M7.813 4.826c-.286-.3-.275-.775.024-1.06.3-.287.775-.276 1.06.024l6.72 7.036c.222.233.346.544.346.866 0 .323-.124.634-.346.866l-6.72 7.037c-.285.3-.76.31-1.06.024-.3-.286-.31-.76-.024-1.06l6.557-6.867-6.557-6.866z',
});
